import { byMethod } from '@oysterjs/core/graphql/actions';
import { merge } from '@oysterjs/core/graphql/loaders';
import type { RouteObject } from 'react-router-dom';
import {
  submitBulkDeleteMemories,
  submitBulkDemoteMemories,
  submitBulkPinMemories,
  submitBulkPromoteMemories,
  submitUpdateMemory
} from '~/api/data/memory/mutations';
import { loadCurrentUser } from '~/api/data/users/queries';
import { SettingsMemoryPage } from '~/pages/settings/memory';

export const memoryRoute: RouteObject = {
  path: 'memory',
  loader: merge({
    agencyUser: loadCurrentUser
  }),
  element: <SettingsMemoryPage />,
  children: [
    {
      path: 'update',
      action: byMethod({
        POST: submitUpdateMemory
      })
    },
    {
      path: 'bulk-pin',
      action: byMethod({ POST: submitBulkPinMemories })
    },
    {
      path: 'bulk-promote',
      action: byMethod({ POST: submitBulkPromoteMemories })
    },
    {
      path: 'bulk-demote',
      action: byMethod({ POST: submitBulkDemoteMemories })
    },
    {
      path: 'bulk-delete',
      action: byMethod({ POST: submitBulkDeleteMemories })
    }
  ]
};
